module.exports = __webpack_public_path__ + "share-icon.svg?3893ea116aef0f7e1c3b72953a8b161b";